import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState: {},
  reducers: {
    setCompanyDetails: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setCompanyDetails } = companyDetailsSlice.actions;

export const companyDetails = companyDetailsSlice.reducer;

export default companyDetailsSlice.reducer;
